const initState = {
    companies: {
        buy: {
            'MSP Paper Company': [],
            'Microsoft': []
        },
        sell: {
            'MSP Paper Company': [],
            'Microsoft': []
        }
    }
}

const tradebookReducer = (state = initState, action) => {
    switch(action.type) {
        case 'ADD_TO_TRADE_BOOK':
            // add new trade to the trade book            
            // const company = action.information.company;
            // const counterparty = action.information.counterparty;
            // const amount = action.information.amount;
            // const price = action.information.price;
            // const type = action.information.type;

            return {
                ...state,
                /*companies: {
                    ...state.companies,
                    [type]: {
                        ...state.companies[type],
                        [company]: [
                            ...state.companies[type][company],
                        {
                            name: counterparty,
                            amount: amount,
                            price: price,
                        }]
                    }
                }*/
            };
            
        case 'DELETE_FROM_TRADE_BOOK':
            // const exchangeType = action.information.type;
            // const companyName = action.information.company;
            // const idx = action.information.idx;

            // state.companies[exchangeType][companyName].splice(idx, 1);
            
            return {
                ...state,
                /*companies: {
                    ...state.companies,
                    [exchangeType]: {
                        ...state.companies[exchangeType]
                    }
                }*/
            }
        
        case 'FAILED_TRADE_BOOK':
            // a failure occurred
            console.log('A failure occurred: ', action.err)
            return state

        default:
            return state;
    }
}

export default tradebookReducer;